$(document).ready(function() {
	$('body').addClass('vi-color-white');

	$(document).on('click', '.js-vi-color-white', function() {
		$('body').addClass('vi-color-white');
		$('body').removeClass('vi-color-black');
		$('body').removeClass('vi-color-blue');
	});

	$(document).on('click', '.js-vi-color-black', function() {
		$('body').removeClass('vi-color-white');
		$('body').addClass('vi-color-black');
		$('body').removeClass('vi-color-blue');
	});

	$(document).on('click', '.js-vi-color-blue', function() {
		$('body').removeClass('vi-color-white');
		$('body').removeClass('vi-color-black');
		$('body').addClass('vi-color-blue');
	});
});


// WEBPACK FOOTER //
// ./src/js/visually-impaired/color.js